/**
*****************************************
*										                    *
* NAGARRO  - CSX - CONFIDENTIAL         *
*										                    *
*****************************************
*/
import { Component } from '@angular/core';

/**
 * This Train Component is created for train related screen.
 * @export
 * @class LmsTrainComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-train',
  templateUrl: './train.component.html',
  styleUrls: ['./train.component.scss']
})
export class LmsTrainComponent {
  constructor() { }
}
